import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  Divider,
  FormControlLabel,
  FormGroup,
  IconButton,
  TextField,
  Typography,
  Container,
  Grid,
} from "@mui/material";
import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { MultipleContainers } from "./dnd/Multiple-Containers-Sortable/MultipleContainers";
import Slide from "@mui/material/Slide";
import CustomSelect from "./CustomSelect";
import {
  BRAND_COLOR,
  BRAND_COLOR_DARK,
  BUTTON_SHADOW,
} from "../utils/colors";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const CustomDialog = ({
  open,
  mode,
  handleClose,
  modules,
  customAction,
  handleModuleChange,
  currentModuleFields,
  setCurrentModuleFields,
  currentDatabaseFields,
  setCurrentDatabaseFields,
  syncDuration,
  setSyncDuration,
  setDeleteBackupData,
  handleSave,
  selectedModule,
  deleteBackupData,
  handleDeleteField,
  syncAllFields,
  unSelectAllFields,
  syncDurations,
}) => {
  const [fieldSearch, setFieldSearch] = useState("");

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      TransitionComponent={Transition}
    >
      <Container
        maxWidth="xl"
        sx={{
          py: customAction ? 1 : 2,
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Header */}
        {!customAction && (
          <Box sx={{ width: "100%", height: "auto" }}>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 1.5,
              }}
            >
              <Grid
                container
                spacing={2}
                style={{ maxWidth: "500px", width: "100%" }}
                alignItems={"center"}
              >
                <Grid item xs={5}>
                  <Typography>Module Name</Typography>
                </Grid>
                <Grid item xs={7}>
                  {!customAction && (
                    <Autocomplete
                      id="modules-select"
                      fullWidth
                      disabled={mode === "editMode"}
                      size="small"
                      options={modules}
                      autoHighlight
                      getOptionLabel={(option) =>
                        option.plural_label || option.module_name
                      }
                      onChange={handleModuleChange}
                      value={selectedModule}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          inputProps={{
                            ...params.inputProps,
                          }}
                        />
                      )}
                    />
                  )}
                </Grid>
              </Grid>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1.5,
                  flexShrink: 0,
                }}
              >
                <TextField
                  placeholder="Search module fields..."
                  size="small"
                  value={fieldSearch}
                  onChange={(e) => setFieldSearch(e.target.value)}
                  sx={{ width: 280 }}
                />
                <IconButton onClick={handleClose}>
                  <CloseIcon />
                </IconButton>
              </Box>
            </Box>
            <Divider />
          </Box>
        )}

        {/* custom-action mode has no header row — keep the search available */}
        {customAction && (
          <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 1 }}>
            <TextField
              placeholder="Search module fields..."
              size="small"
              value={fieldSearch}
              onChange={(e) => setFieldSearch(e.target.value)}
              sx={{ width: 280 }}
            />
          </Box>
        )}

        {/* Main — field lists shrink to the space left over by the footer */}
        <Box
          sx={{
            width: "100%",
            flexGrow: 1,
            minHeight: 0,
            overflow: "hidden",
          }}
        >
          <MultipleContainers
            currentModuleFields={currentModuleFields}
            setCurrentModuleFields={setCurrentModuleFields}
            currentDatabaseFields={currentDatabaseFields}
            setCurrentDatabaseFields={setCurrentDatabaseFields}
            handleDeleteField={handleDeleteField}
            syncAllFields={syncAllFields}
            unSelectAllFields={unSelectAllFields}
            searchText={fieldSearch}
            setSearchText={setFieldSearch}
          />
        </Box>

        {/* Footer — pinned below the lists so Save is always visible */}
        <Box mt={1.5} sx={{ flexShrink: 0 }}>
            <Box>
              {!customAction && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "center",
                    gap: "1rem",
                  }}
                >
                  <Typography sx={{ fontSize: "14px" }}>
                    Sync Frequently:
                  </Typography>

                  <CustomSelect
                    selectedValue={syncDuration}
                    items={syncDurations}
                    setValue={(selectedValue) => {
                      const convertIntoHours = selectedValue / 60;
                      const label = Number.isInteger(convertIntoHours)
                        ? `${convertIntoHours} Hours`
                        : `${convertIntoHours * 60} Mins`;

                      setSyncDuration({
                        label: label,
                        total_in_minutes: selectedValue,
                      });
                    }}
                    labelFieldName={"label"}
                    keyFieldName={"total_in_minutes"}
                  />
                </Box>
              )}

              <FormGroup
                onChange={(e) => setDeleteBackupData(e.target.checked)}
              >
                <FormControlLabel
                  control={<Checkbox checked={deleteBackupData} />}
                  label="Delete backup data after 30 days from mysql database?"
                />
              </FormGroup>
            </Box>

            <Divider />

            <DialogActions sx={{ p: 0, py: 1 }}>
              <Button
                onClick={() => handleSave()}
                autoFocus
                variant="contained"
                sx={{
                  backgroundColor: BRAND_COLOR,
                  boxShadow: BUTTON_SHADOW,
                  "&:hover": {
                    backgroundColor: BRAND_COLOR_DARK,
                  },
                  textTransform: "capitalize",
                }}
              >
                Save Settings
              </Button>
            </DialogActions>
        </Box>
      </Container>
    </Dialog>
  );
};

export default CustomDialog;
